var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-toolbar",
    _vm._g(
      _vm._b(
        { attrs: { dense: "", dark: "", color: "primary" } },
        "v-toolbar",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("v-spacer"),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { icon: "", dark: "" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("v-icon", [_vm._v("close")])],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }